import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
import { Button } from '../ui/Button';
import { Card } from '../ui/Card';
import { AnimatedSection, staggerContainer, staggerItem } from './AnimatedSection';
import { calendarEvents } from './homeData';
interface AstroCalendarSectionProps {
  onNavigate: (page: string) => void;
}
export function AstroCalendarSection({
  onNavigate
}: AstroCalendarSectionProps) {
  return <AnimatedSection className="py-8 sm:py-24 bg-slate-50" data-id="element-16282">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-16283">
        <div className="flex justify-between items-end mb-4 sm:mb-12" data-id="element-16284">
          <div data-id="element-16285">
            <h2 className="text-lg sm:text-3xl font-bold text-slate-900 mb-1 sm:mb-3" data-id="element-16286">
              Астрологический календарь
            </h2>
            <p className="text-xs sm:text-lg text-slate-500" data-id="element-16287">
              Важные небесные события
            </p>
          </div>
          <Button variant="ghost" className="hidden md:flex text-slate-500" onClick={() => onNavigate('astro-daily')} data-id="element-16288">
            Открыть календарь <ArrowRight className="ml-2 w-4 h-4" data-id="element-16289" />
          </Button>
        </div>

        {/* Mobile: compact list */}
        <div className="sm:hidden space-y-2.5" data-id="element-16290">
          {calendarEvents.map(event => <div key={event.id} className="flex items-center gap-3 bg-white rounded-xl border border-slate-100 p-3 cursor-pointer" onClick={() => onNavigate('calendar-event')} data-id="element-16291">
              <div className={`p-2 rounded-lg border ${event.accent} flex-shrink-0`} data-id="element-16292">
                {event.icon}
              </div>
              <div className="min-w-0" data-id="element-16293">
                <div className="flex items-center gap-2" data-id="element-16294">
                  <span className="text-[10px] font-bold text-slate-400 uppercase" data-id="element-16295">
                    {event.type}
                  </span>
                  <span className="text-[10px] font-bold text-slate-900" data-id="element-16296">
                    {event.date}
                  </span>
                </div>
                <h3 className="text-xs font-bold text-slate-900" data-id="element-16297">
                  {event.title}
                </h3>
              </div>
            </div>)}
        </div>

        {/* Desktop: grid */}
        <motion.div className="hidden sm:grid md:grid-cols-3 gap-6" variants={staggerContainer} initial="hidden" whileInView="visible" viewport={{
        once: true
      }} data-id="element-16298">
          {calendarEvents.map(event => <motion.div key={event.id} variants={staggerItem} data-id="element-16299">
              <Card hoverable padding="lg" className="cursor-pointer border-slate-100 h-full" onClick={() => onNavigate('calendar-event')} data-id="element-16300">
                <div className="flex items-center gap-3 mb-4" data-id="element-16301">
                  <div className={`p-2.5 rounded-xl border ${event.accent}`} data-id="element-16302">
                    {event.icon}
                  </div>
                  <div data-id="element-16303">
                    <div className="text-xs font-bold text-slate-400 uppercase tracking-wider" data-id="element-16304">
                      {event.type}
                    </div>
                    <div className="text-sm font-bold text-slate-900" data-id="element-16305">
                      {event.date}
                    </div>
                  </div>
                </div>
                <h3 className="text-lg font-bold text-slate-900 mb-2" data-id="element-16306">
                  {event.title}
                </h3>
                <p className="text-sm text-slate-500" data-id="element-16307">{event.desc}</p>
              </Card>
            </motion.div>)}
        </motion.div>
      </div>
    </AnimatedSection>;
}